module.exports = __webpack_public_path__ + "img/enterprise-img.f1b8ed96.png";